import { z } from 'zod/v4-mini';

import { useLocalizationStore } from '$/components/core/Localization/hooks/useLocalizationStore';
import { backendEndpoints } from '$/services/endpoints';
import { fetcher } from '$/services/fetcher';
import {
  type MaterialFilterOption,
  type SpectrumWidgetRequest,
} from '$/services/usecases/materials';
import { MaterialSchema } from '$/services/usecases/materials/mapper/materials';

export const SearchMaterialsSchema = z.object({
  '@odata.count': z.number(),
  colorCount: z.optional(z.number()),
  value: z.array(MaterialSchema),
});

type Payload = {
  brightnessFilter?: number[];
  filter?: MaterialFilterOption[];
  limit?: number;
  order?: string;
  query?: string;
  skip?: number;
  signal?: AbortSignal;
  countryOverwrite?: string;
  isDemo?: boolean;
  spectrumWidget?: SpectrumWidgetRequest;
  includeCredentials?: boolean;
};

export const searchMaterials = async (payload: Payload = {}) => {
  const {
    filter,
    limit,
    order,
    query,
    skip,
    signal,
    countryOverwrite,
    isDemo,
    spectrumWidget,
    includeCredentials,
  } = payload;
  const country = useLocalizationStore.getState().country;

  const response = await fetcher(backendEndpoints.MATERIAL_URL, {
    signal,
    body: {
      filter,
      order,
      query,
      skip: skip ?? 0,
      top: limit ?? 50,
      country: countryOverwrite ?? country,
      isDemo: isDemo ?? false,
      spectrumWidget,
    },
    method: 'POST',
    parser: (data) => SearchMaterialsSchema.parse(data),
    includeCredentials: includeCredentials ?? true,
  });

  return {
    count: response.response['@odata.count'],
    colorCount: response.response.colorCount,
    results: response.response.value,
  };
};
